export default "__VITE_ASSET__43e17ec1__"